<script lang="ts">
    import { _ } from "svelte-i18n"

    import { location } from "../../store"
    import { baseURL } from "../../configs/config"

    let {
        metaDescription = "",
        pageTitle = "",
        imageUrl = "",
    }: {
        metaDescription: string
        pageTitle: string
        imageUrl: string
    } = $props()
    const image = imageUrl ? imageUrl : `${baseURL}/api/_/assets/logo/dark.png`
</script>

<svelte:head>
    <meta property="og:locale" content={"de_DE"} />
    <meta property="og:url" content={$location.url} />
    <meta property="og:type" content={"website"} />
    <meta property="og:title" content={pageTitle} />
    <meta property="og:description" content={metaDescription} />

    <meta property="og:image" content={image} />
    <meta property="og:image:alt" content={$_("general.companyName")} />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={pageTitle} />
    <meta name="twitter:description" content={metaDescription} />
    <meta name="twitter:image" content={image} />
    <meta name="twitter:image:alt" content={$_("general.companyName")} />
</svelte:head>
